import {ICustomer} from './customer.model';
import {IOrganization} from './organization.model';
import {IEmployee} from "./employee.model";
import {ISupplier} from "./supplier.model";

export interface IPhone {
  id?: number;
  audience?: string;
  description?: string;
  master?: number;
  jhiMaster?: number;
  jhiNumber?: string;
  phoneNumber?: string;
  status?: string;
  gender?: string;
  firstName?: string;
  lastName?: string;
  toNumber?: string;
  email?: string;
  prefix?: string;
  jhiType?: string;
  position?: string;
  phone?: IPhone;
  customer?: ICustomer;
  supplier?: ISupplier;
  employee?: IEmployee;
  organization?: IOrganization;

}

export class Phone implements IPhone {
  constructor(public id?: number,
              public audience?: string,
              public description?: string,
              public master?: number,
              public jhiMaster?: number,
              public jhiNumber?: string,
              public firstName?: string,
              public lastName?: string,
              public toNumber?: string,
              public email?: string,
              public gender?: string,
              public prefix?: string,
              public phoneNumber?: string,
              public status?: string,
              public jhiType?: string,
              public customer?: ICustomer,
              public supplier?: ISupplier,
              public employee?: IEmployee,
              public organization?: IOrganization) {
  }
}
